import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetReportTopCategories } from '../../hooks/reports/useGetReportTopCategories';
import TopEntitiesCard from './TopEntitiesCard';

const TopCategories = ({ filter, limit = 10 }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const { items, isLoading } = useGetReportTopCategories({
        from: filter.from,
        to: filter.to,
        limit,
    });

    return (
        <TopEntitiesCard
            title={isArabic ? 'أعلى الفئات مبيعاً' : 'Top categories'}
            items={items}
            isLoading={isLoading}
            color="info"
        />
    );
};

export default TopCategories;
